export default __webpack_public_path__ + "static/media/DE.1fd85344.svg";